<template>
  <div>
    <cultural></cultural>
  </div>
</template>

<script>
import cultural from '@views/appletManagement/cultural-creation'
export default {
  data() {
    return {
      
    };
  },
  components:{
    cultural
  },

  mounted() {
    
  },

  methods: {
    
  },
};
</script>

<style lang="scss" scoped>

</style>